define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../utils/dateUtils", "../../utils/LookupDataSources", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DateUtils, LookupDataSources, UserContext) {
    "use strict";
    var CommissionsReport = /** @class */ (function () {
        function CommissionsReport() {
            this.filterCustomersCreationReportByStartDate = ko.observable(DateUtils.firstDayOfMonth());
            this.filterCustomersCreationReportByEndDate = ko.observable(DateUtils.lastDayOfMonth());
            this.filterByCustomer = ko.observable("");
            this.filterByEmployee = ko.observable("");
            this.canEdit = ko.observable(UserContext.hasAccess("Admin,Commissions.Edit,Commissions.Delete"));
            this.canExport = ko.observable(UserContext.hasAccess("Admin,Commissions.Export"));
        }
        CommissionsReport.prototype.init = function () {
            var self = this;
            $("#page-title").text("Commission Report");
            tools.ajaxGet({
                url: "/Commissions/GetCommissionReportLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookups = data.Data.lookupLists;
                        self.initGrid(self.lookups.GridStructures.CommissionReportStructure);
                        ko.applyBindings(self, document.getElementById("main-container"));
                        var lookupDataSources = new LookupDataSources();
                        var employeesDS = lookupDataSources.createLookupDataSource("Employees");
                        var customersDS = lookupDataSources.createLookupDataSource("Customers");
                        self.employeesDropdown = $("input[name=filterByEmployee]").kendoDropDownList({
                            dataSource: employeesDS,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            optionLabel: "Filter By Member",
                            filter: "contains",
                            change: function (e) {
                                var dataItem = e.sender.dataItem();
                                if (dataItem) {
                                    self.filterByEmployee(dataItem.Id);
                                }
                                else {
                                    self.filterByEmployee("");
                                }
                            }
                        }).data("kendoDropDownList");
                        self.customersDropdown = $("input[name=filterByCustomer]").kendoDropDownList({
                            dataSource: customersDS,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            optionLabel: "Filter By Customer",
                            filter: "contains",
                            change: function (e) {
                                var dataItem = e.sender.dataItem();
                                if (dataItem) {
                                    self.filterByCustomer(dataItem.Id);
                                }
                                else {
                                    self.filterByCustomer("");
                                }
                            }
                        }).data("kendoDropDownList");
                    }
                    else {
                        log.error(data.Error);
                    }
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CommissionsReport.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblCommissionReportKendo";
            var columns = gridStructure.columns;
            if (self.canEdit()) {
                var actions = {
                    field: "",
                    command: ["edit"],
                    width: "86px"
                };
                columns.push(actions);
            }
            self.reportTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Commissions/GetCommissionData",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.fromdate = DateUtils.toIsoStringDate(self.filterCustomersCreationReportByStartDate());
                                data.todate = DateUtils.toIsoStringDate(self.filterCustomersCreationReportByEndDate());
                                if (self.filterByCustomer()) {
                                    data.customerId = self.filterByCustomer();
                                }
                                if (self.filterByEmployee()) {
                                    data.employeeId = self.filterByEmployee();
                                }
                                return data;
                            },
                            dataType: "json"
                        },
                        update: {
                            url: "/Commissions/SaveCommission/",
                            data: function () {
                                var data = {};
                                data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
                                return data;
                            },
                            dataType: "json",
                            type: "POST"
                        }
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    batch: false,
                    sort: { field: "PaidDate", dir: "desc" },
                    schema: {
                        model: gridStructure.model
                    },
                    error: function (e) {
                        console.log("error", e);
                        self.reportTable.getGridData().cancelChanges();
                    },
                    aggregate: gridStructure.aggregate,
                    serverAggregates: true
                },
                gridOptions: {
                    toolbar: kendo.template($("#commissionreport-toolbar-template").html()),
                    columns: columns,
                    editable: {
                        mode: "inline"
                    },
                    resizable: true,
                    reorderable: true,
                    scrollable: true,
                    columnMenu: true,
                    dataBound: function (e) {
                        var grid = self.reportTable.getGridData();
                        var gridData = grid.dataSource.view();
                        for (var i = 0; i < gridData.length; i++) {
                            var currentUid = gridData[i].uid;
                            if (gridData[i].IsApproved) {
                                var currenRow = grid.table.find("tr[data-kendo-uid='" + currentUid + "']");
                                var editButton = $(currenRow).find(".k-grid-edit");
                                editButton.hide();
                            }
                        }
                    },
                    filterable: {
                        mode: "row",
                        extra: false
                    },
                    edit: function (e) {
                        e.container.find("td input[type=text]").focus();
                    }
                },
                enableExport: {
                    entityName: "Commission",
                    title: "Commission Report",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: self.canExport()
                },
                gridId: gridId,
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.reportTable.initGrid(gridOptions);
            self.filterByCustomer.subscribe(function () {
                self.reportTable.refresh();
            });
            self.filterByEmployee.subscribe(function () {
                self.reportTable.refresh();
            });
            self.filterCustomersCreationReportByStartDate.subscribe(function () {
                self.reportTable.refresh();
            });
            self.filterCustomersCreationReportByEndDate.subscribe(function () {
                self.reportTable.refresh();
            });
        };
        CommissionsReport.prototype.clearFilter = function () {
            var self = this;
            self.filterCustomersCreationReportByStartDate(DateUtils.firstDayOfMonth());
            self.filterCustomersCreationReportByEndDate(DateUtils.lastDayOfMonth());
            self.filterByCustomer("");
            self.filterByEmployee("");
            self.employeesDropdown.value(null);
            self.customersDropdown.value(null);
        };
        CommissionsReport.prototype.approveConfirm = function () {
            var self = this;
            var confirmText = "all items in selected date range";
            var selectedCount = self.reportTable.getSelectedRowsCount();
            if (selectedCount > 0) {
                confirmText = selectedCount + " selected items?";
            }
            tools.confirmModal({
                title: "Approve commissions",
                text: "Are you sure you want to approve " + confirmText,
                buttonTitle: "Confirm",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.approveCommissions(true);
            });
        };
        CommissionsReport.prototype.disapproveConfirm = function () {
            var self = this;
            var confirmText = "all items in selected date range";
            var selectedCount = self.reportTable.getSelectedRowsCount();
            if (selectedCount > 0) {
                confirmText = selectedCount + " selected items?";
            }
            tools.confirmModal({
                title: "Disapprove commissions",
                text: "Are you sure you want to disapprove " + confirmText,
                buttonTitle: "Confirm",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.approveCommissions(false);
            });
        };
        CommissionsReport.prototype.approveCommissions = function (approve) {
            var self = this;
            var ids = [];
            var selectedItems = self.reportTable.getSelectedRows();
            if (selectedItems) {
                ko.utils.arrayForEach(selectedItems, function (item) {
                    ids.push(item.Id);
                });
            }
            var data = {
                fromdate: DateUtils.toIsoStringDate(self.filterCustomersCreationReportByStartDate()),
                todate: DateUtils.toIsoStringDate(self.filterCustomersCreationReportByEndDate()),
                approve: approve,
                ids: ids.join(",")
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Commissions/ApproveCommissions",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Commissions approved successfully");
                    self.reportTable.refresh();
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CommissionsReport.prototype.recalculateConfirm = function () {
            var self = this;
            self.reportTable.getSelectedRowsCount();
            var confirmText = "all items in selected date range";
            var selectedCount = self.reportTable.getSelectedRowsCount();
            if (selectedCount > 0) {
                confirmText = selectedCount + " selected items?";
            }
            tools.confirmModal({
                title: "Recalculate commissions",
                text: "Are you sure you want to recalculate " + confirmText,
                buttonTitle: "Confirm",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.recalculateCommissions();
            });
        };
        CommissionsReport.prototype.recalculateCommissions = function () {
            var self = this;
            var ids = [];
            var selectedItems = self.reportTable.getSelectedRows();
            if (selectedItems) {
                ko.utils.arrayForEach(selectedItems, function (item) {
                    ids.push(item.InvoiceId);
                });
            }
            var data = {
                fromdate: DateUtils.toIsoStringDate(self.filterCustomersCreationReportByStartDate()),
                todate: DateUtils.toIsoStringDate(self.filterCustomersCreationReportByEndDate()),
                ids: ids.join(",")
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Commissions/RecalculateCommissions",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Commissions recalculated successfully");
                    self.reportTable.refresh();
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CommissionsReport.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.reportTable.exportTo();
            }
        };
        return CommissionsReport;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Commissions/CommissionReport")) {
            log.log("Initialize CommissionReport list");
            $(function () {
                (new CommissionsReport()).init();
            });
        }
    }, 0);
    return CommissionsReport;
});
//# sourceMappingURL=commissionsReport.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/commission/commissionsReport.js
// module id = 307
// module chunks = 2